import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextInputComponent } from 'src/app/shared/components/inputs/text-input/text-input.component';
import { ButtonComponent } from 'src/app/shared/components/inputs/button/button.component';
import { TextInput } from 'src/utils/models/input.interface';
import { HttpService } from 'src/app/service/http/http.service';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
export interface NewConnection {
  name: string;
  project_id: string;
}

@Component({
  selector: 'app-create-connection-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextInputComponent,
    ButtonComponent,
    MatIconModule
  ],
  templateUrl: './create-connection-modal.component.html',
  styleUrls: ['./create-connection-modal.component.scss']
})

export class CreateConnectionModalComponent implements OnInit {
  form: FormGroup;
  connectionNameInput: TextInput;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreateConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private httpService: HttpService,
    private toastr: ToastrService
  ) {
    this.form = this.fb.group({
      connectionName: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.connectionNameInput = {
      value: '',
      label: 'Nome da conexão',
      placeholder: 'Digite o nome da conexão',
      maxLength: '60',
      required: { active: true }
    };
  }

  onCreate(): void {
    if (this.form.valid) {
      this.submitConnection();
    } else {
      this.toastr.show('Por favor, preencha o nome da conexão', 'Aviso', {
        timeOut: 6000,
        messageClass: 'warning'
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private submitConnection(): void {
    this.isLoading = true;
    const projectId = sessionStorage.getItem('projectId');

    if (!projectId) {
      this.toastr.show('ProjectId não encontrado. Faça login novamente.', 'Erro', {
        timeOut: 6000,
        messageClass: 'error'
      });
      this.isLoading = false;
      return;
    }

    const newConnection: NewConnection = {
      name: this.form.get('connectionName')?.value,
      project_id: projectId
    };

    // Usando genericPost com FormData
    this.httpService.genericPost<any>('sources', newConnection, '').subscribe({
      next: (response) => {
        this.isLoading = false;
        this.dialogRef.close({
          success: true,
          connectionId: response._id,
          data: response
        });
        this.toastr.show('Conexão criada com sucesso', 'Sucesso', {
          timeOut: 6000,
          messageClass: 'success'
        });
      },
      error: (err) => {
        this.isLoading = false;
        const errorMessage = err?.error?.message || err?.message || 'Erro ao criar conexão. Tente novamente.';
        this.toastr.show(errorMessage, 'Erro', {
          timeOut: 6000,
          messageClass: 'error'
        });
      }
    });
  }

}

